// extracted by mini-css-extract-plugin
export var callCard = "_l5-0";
export var callMessageButton = "_l5-1";
export var helpIcon = "_l5-3";
export var helpIconContainer = "_l5-4";
export var verticalDivider = "_l5-2";